import { FC } from 'react'

import { useParams } from '@tanstack/react-router'

import { Cluster, Grid, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'

import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { BookingOverviewTabLayout } from '../BookingLayout'
import { BookingDetailsTitleSkeleton } from '../details/BookingDetailsSkeleton'

export const BookingPriceBreakdownSkeleton: FC = () => {
  const { translate } = useLocalisation()
  const { id } = useParams({
    from: '/bookings/$id/price-breakdown',
  })

  return (
    <BookingOverviewTabLayout
      title={<BookingDetailsTitleSkeleton />}
      sidebar={<WidgetSkeleton count={1} />}
      main={
        <Stack gap={16}>
          <Skeleton variant="content" size={16} fullWidth />
          {Array.from({ length: 2 }).map((_, index) => (
            <Stack gap={16} key={index}>
              <Grid col={6}>
                <Skeleton variant="badge" fullWidth />
              </Grid>
              <Table
                columns={[
                  {
                    accessorKey: 'name',
                    header: translate('booking.breakdown.table.lineItem'),
                    cell: () => <Skeleton variant="content" />,
                  },
                  {
                    accessorKey: 'quantity',
                    header: translate('booking.breakdown.table.quantityPerUnit'),
                    cell: () => <Skeleton variant="content" />,
                  },
                  {
                    accessorKey: 'total',
                    header: translate('booking.breakdown.table.quotePrice'),
                    cell: () => <Skeleton variant="content" />,
                  },
                  {
                    accessorKey: 'totalEUR',
                    header: translate('booking.breakdown.table.invoiceNetPrice'),
                    cell: () => <Skeleton variant="content" />,
                    footer: () => {
                      return (
                        <Stack gap={12}>
                          <Cluster />
                          <Grid col={4}>
                            <Skeleton variant="badge" fullWidth />
                          </Grid>
                          <Cluster />
                        </Stack>
                      )
                    },
                  },
                ]}
                data={[{}]}
                footless
              />
            </Stack>
          ))}
        </Stack>
      }
      bookingId={id}
    />
  )
}
